import React from "react";
//import FlagIcon from "@mui/icons-material/Flag";
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';

const SentimentFlag = ({ sentimentFlag }) => {
  const flagColor =
    sentimentFlag.toLowerCase() === "positive"
      ? "#59A150" //green
      : sentimentFlag.toLowerCase() === "negative"
      ? "#DF5959" // reddish
      : "grey"; //neutral

  return (
    <span>
      {/* <FlagOutlinedIcon style={{ color: flagColor }} /> */}
    </span>
  );
};

export default SentimentFlag;
